module.exports = __webpack_public_path__ + "img/1.74346a7f.png";